export const PRIMARY_CLASS = 'dp-form-data-trigger';
export const ORDER_BY_OPTION_CONTROL_TYPE = 'Control Type';
export const ORDER_BY_OPTION_NAME = 'Name';
export const ORDER_BY_OPTIONS = [ORDER_BY_OPTION_CONTROL_TYPE, ORDER_BY_OPTION_NAME];
